import React from "react";
import Tippy from '@tippyjs/react';
import { TextInput } from "@opendate-app/setlist";

import FanFilterSelect from "./FanFilterSelect";
import useQueuedFilterParams from "./useQueuedFilterParams";

import { formInputContainerStyle } from "./FanFilterGroupForm";

const DAYS_WIDTH = 120;

const EventViewForm = (props) => {
  const {
    fanFilter,
    updateFanFilter,
  } = props;

  const options = fanFilter.filter_param_options;
  const { params, update, commitText } = useQueuedFilterParams(fanFilter, updateFanFilter);

  const eventOptions = (options.events || []).map((event) => ({
    value: event.id,
    label: event.name,
  }));

  return (
    <>
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Condition"
          placeholder="Select a condition"
          options={(options.condition || []).map((value) => ({ value, label: value }))}
          value={params.condition || null}
          onChange={(value) => update({ condition: value })}
        />
      </div>

      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Event"
          placeholder="Select an event"
          searchable
          options={eventOptions}
          value={params.calendar_event_id || null}
          onChange={(value) => update({ calendar_event_id: value })}
        />
      </div>

      <div style={{ ...formInputContainerStyle, display: "flex", alignItems: "center", gap: 8 }}>
        <div style={{ width: DAYS_WIDTH }}>
          <TextInput
            key={`${fanFilter.id}-within_days`}
            aria-label="Days to look back"
            type="number"
            min="1"
            max={options.max_within_days}
            step="1"
            placeholder="Days"
            defaultValue={params.within_days ?? ""}
            onBlur={(e) => commitText("within_days", e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") commitText("within_days", e.target.value);
            }}
          />
        </div>
        <span style={{ color: "var(--sl-text-secondary)" }}>days</span>
        <Tippy content="Only fans who were logged in to Opendate when they viewed this event's page or opened its ticket window. Anonymous visitors can't be included.">
          <i className="far fa-circle-info" aria-label="Logged-in visitors only" style={{ color: "var(--sl-text-tertiary)" }}/>
        </Tippy>
      </div>

      {fanFilter.filter_validation_errors.length ? (
        <Tippy content={fanFilter.filter_validation_errors.join(" ")}>
          <i className="far fa-circle-exclamation" style={{color: "var(--sl-text-error, #FF595E)" }}/>
        </Tippy>
      ) : null}
    </>
  );
};

export default EventViewForm;
